import http from "../api";

export const loginUser = async (data) => {
  return await http.post("/user/login", data);
};

export const forgotPassword = async (data) => {
  return await http.post("/user/forgot-password", data);
};

export const validateOTP = async (data) => {
  return await http.post("/user/verify-otp", data);
};

export const resendOTP = async (data) => {
  return await http.post("/user/resend-otp", data);
};

export const resetPassword = async (data) => {
  return await http.put("/user/reset-password", data);
};

export const changePassword = async (data) => {
  return await http.patch("/user/change-password", data);
};

export const switchUser = async (id) => {
  return await http.get(`/user/switch-user/${id}`);
};
